/* BEO app : pages Flash Sale et collections (maquettes validées par Fleur le 21/09/2026).
   Ne fait RIEN hors de l'app : tout part de la classe html.beo-app posée par le détecteur
   de sections/beo-seo-schema.liquid. Le CSS qui va avec est dans assets/beo-app-only.css
   (sections 7 à 10, 15, 20 à 22).

   Ce que fait ce fichier :
   - Flash Sale : en-tête « Flash Sale · LIVE · N deals · loupe », et le bandeau du prochain
     drop sort de la barre collante pour passer au-dessus des pastilles ;
   - collections : flèche retour et loupe sur la photo du comptoir, puis une barre collante
     avec les pastilles de sous-catégories (« All » en premier) qui prend le nom du comptoir,
     la flèche et la loupe quand la photo sort de l'écran ;
   - cartes : « Frozen » sort du nom (le pictogramme le dit), « pack of » sort du poids ;
   - Rewards : le cadeau, sur la home de l'app et dans la barre de l'onglet Account ;
   - appui façon iOS sur tout ce qui se touche ;
   - écran d'attente à notre logo entre deux pages (à voir avec ?beo_load=1).

   Retour : l'historique si on vient du site, sinon le Market. Sur iPhone il n'y a pas de
   bouton retour système ; sur Android le bouton du téléphone fait la même chose. */
/* ---- Hors app aussi (site + app) ---- */

/* RECHERCHE (retour Fleur 21/09 : « il faut taper le nom entier »).
   beo-app-search-bridge.js préfixe chaque mot par title: pour que « cheese » ne ramène plus
   les 98 produits dont la description cite du fromage. Effet de bord : Shopify ne cherche
   alors que des mots ENTIERS (title:salm = 0 résultat, salm = 7). Quand la recherche par
   titre ne trouve rien, on la relance une fois sans title: et en préfixe sur le dernier mot.
   beo_fb=1 empêche toute boucle. */
(function () {
  if (location.pathname.indexOf('/search') !== 0) return;
  var p = new URLSearchParams(location.search);
  var q = p.get('q') || '';
  var S = window.BEOSearch; // 2026-10-31 : requete construite par assets/beo-search-query.js
  if ((S ? !S.isBuilt(q) : q.indexOf('title:') === -1) || p.get('beo_fb')) return;
  function check() {
    if (document.querySelector('.product-item')) return;
    var plain = S ? S.human(q) : q.replace(/title:/g, '').replace(/\s+/g, ' ').trim();
    if (!plain) return;
    p.set('q', plain);
    p.set('type', 'product');
    p.set('options[prefix]', 'last');
    p.set('beo_fb', '1');
    location.replace('/search?' + p.toString());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();

/* HOME DE L'APP : photos des comptoirs (retour Fleur 21/09, « elles mettent du temps à
   charger, on voit d'abord l'aplat coloré »). Les bandes chargeaient l'original (jusqu'à
   2600 px) en lazy : servies en 800 px par le CDN Shopify (moitié du poids), puis
   préchargées dès que la page a fini de charger, avant qu'on les atteigne en scrollant.
   22/09 (Fleur : « encore l'aplat par moments », lent aussi sur Android) : attendre le « load »
   était trop tard, il attend aussi la grande photo du hero. Les bandes partent maintenant dès
   que la page est lue, et Little Foodies (dans les fichiers Shopify, pas les assets) est
   aussi servie en 800 px au lieu de 1600. */
(function () {
  function run() {
    if (!document.body.classList.contains('template-page-app-home')) return;
    var imgs = document.querySelectorAll('.beo-home--sez .bhz-band img, .beo-home--sez .bhz-about img');
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if ((src.indexOf('/assets/') > -1 || src.indexOf('/files/') > -1) && src.indexOf('width=') === -1) {
        img.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800');
      }
      img.decoding = 'async';
      img.loading = 'eager';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ---- App seulement ---- */
(function () {
  var H = document.documentElement;
  if (!H.classList.contains('beo-app')) return;

  /* Le lockup court (B + BONEATO). Même fichier que le fond des photos qui chargent
     (section 22 de beo-app-only.css) : si le logo change, le remplacer aux DEUX endroits. */
  var LOGO = 'https://cdn.shopify.com/s/files/1/1017/9431/6629/files/beo-logo-v22-short-720.png?v=1790066116&width=420';

  var ICON = {
    search: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    back: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    /* Cadeau : l'icône dessinée par Capucine (~/Desktop/BONEATO-icone-rewards/BONEATO-rewards-gift.svg),
       passée en currentColor pour prendre la couleur de la barre où elle est posée. */
    share: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V4M8 8l4-4 4 4"/><path d="M5 12v7h14v-7"/></svg>',
      gift: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4.5" rx="1"/><path d="M5 13v7.5h14V13"/><path d="M12 8.5v12"/><path d="M12 8.5C10.6 5 7 4.3 7 6.6 7 8 9.2 8.5 12 8.5z"/><path d="M12 8.5c1.4-3.5 5-4.2 5-1.9 0 1.4-2.2 1.9-5 1.9z"/></svg>'
  };

  /* Sous-collection -> comptoir. Même liste que sections/beo-collection-hero.liquid :
     ajouter une sous-collection là-bas = l'ajouter ici aussi (sinon « All » pointe sur elle). */
  var PARENT = {};
  [
    ['the-fishmonger', 'fillets-whole-fish,shellfish-crustaceans,smoked-fine-foods,tools'],
    ['the-butcher', 'beef,lamb,veal-game,poultry,pork,deli-charcuterie'],
    ['the-greengrocer', 'vegetables,fruits,the-veggie-pantry'],
    ['the-cheesemonger', 'cheesemonger-selection,alleosse-selection,the-dairy-pantry'],
    ['the-grocer', 'antipasti,pasta-grains-pulses,oils-vinegars,sauces-spices,jams-chocolate-sweets'],
    ['drinks-store', 'white-wine,red-wine,champagne-sparkling,rose-aperitifs,healthy-drinks'],
    ['the-baker', 'bread-pastries,cakes-desserts'],
    ['little-foodies', 'baby-food-purees,kids-snacks']
  ].forEach(function (p) { p[1].split(',').forEach(function (s) { PARENT[s] = p[0]; }); });

  function goBack(e) {
    e.preventDefault();
    if (history.length > 1 && document.referrer.indexOf(location.host) > -1) history.back();
    else location.href = '/pages/market';
  }

  function btn(cls, href, label, icon) {
    var a = document.createElement('a');
    a.className = 'beo-appbtn' + (cls ? ' ' + cls : '');
    a.href = href;
    a.setAttribute('aria-label', label);
    a.innerHTML = icon;
    if (label === 'Back') a.addEventListener('click', goBack);
    return a;
  }

  function cleanCards() {
    document.querySelectorAll('.product-item .beo-name:not([data-beo-app])').forEach(function (n) {
      n.setAttribute('data-beo-app', '1');
      n.textContent = n.textContent.replace(/^\s*Frozen\s+/i, '');
    });
    /* 08/10 : le « pack of » n'est plus retiré ici - product-item.liquid ne garde que la taille, site et app. */
  }

  function flash() {
    var nav = document.getElementById('flash-nav');
    var sec = nav && nav.closest('.shopify-section');
    if (!sec || document.querySelector('.beo-apphead')) return;
    var head = document.createElement('div');
    head.className = 'beo-apphead';
    head.innerHTML = '<div class="beo-apphead__t"><span class="beo-apphead__h">Flash Sale</span><span class="beo-apphead__live">Live</span></div><div class="beo-apphead__r"></div>';
    var right = head.querySelector('.beo-apphead__r');
    /* 01/10 : le compteur « N deals » est retiré (retour Capucine 29/09). */
    right.appendChild(btn('', '/pages/rewards', 'Rewards', ICON.gift));
    right.appendChild(btn('', '/search', 'Search', ICON.search));
    sec.parentNode.insertBefore(head, sec);
    /* 01/10 : le bandeau « Next drop » est retiré de l'app (retour 29/09), masqué en CSS
       (html.beo-app #beo-flash-next). Il reste dans le DOM : beo-flash-countdown.js le cherche. */
    /* 03 : la pastille choisie est gardée pour la session et réappliquée au retour.
       05/10 : au rechargement, c'est head-preloader.liquid + layout/theme.liquid qui la posent
       avant le premier pixel (plus de saut) ; restore() ci-dessous n'est plus qu'un filet,
       sans effet si la pastille est déjà active (cas normal). */
    var KEY = 'beo-flash-cat';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.flash-nav-tab');
      if (!t) return;
      if (window.beoMem) window.beoMem.set(KEY, { c: t.getAttribute('data-filter') || 'all', t: Date.now() });
    }, true);
    var restore = function () {
      /* 06/10 : mémoire partagée par les écrans de l'app (head-preloader.liquid), 30 min. */
      var m = window.beoMem ? window.beoMem.get(KEY) : null;
      var c = m && Date.now() - m.t < 1800000 ? m.c : '';
      if (!c || c === 'all') return;
      var tab = document.querySelector('.flash-nav-tab[data-filter="' + c + '"]');
      if (tab && !tab.classList.contains('active')) tab.click();
    };
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore);
    window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
  }

  function collection() {
    var hero = document.querySelector('.beo-ch-v2');
    var sec = hero && hero.closest('.shopify-section');
    if (!sec || document.querySelector('.beo-appbar')) return;
    var titleEl = hero.querySelector('.beo-ch-title');
    var title = titleEl ? titleEl.textContent.trim() : '';

    /* Boutons « verre » sur la photo des 7 comptoirs ; les collections mood n'ont qu'un
       aplat pastel, où du blanc translucide ne se voit pas : boutons pleins. */
    var photo = getComputedStyle(hero).backgroundImage !== 'none';
    var glass = photo ? 'beo-appbtn--glass' : '';
    var hb = document.createElement('div');
    hb.className = 'beo-herobtns';
    hb.appendChild(btn(glass, '/pages/market', 'Back', ICON.back));
    hb.appendChild(btn(glass, '/search', 'Search', ICON.search));
    hero.appendChild(hb);

    var bar = document.createElement('div');
    bar.className = 'beo-appbar';
    var row = document.createElement('div');
    row.className = 'beo-appbar__row';
    row.appendChild(btn('', '/pages/market', 'Back', ICON.back));
    var t = document.createElement('span');
    t.className = 'beo-appbar__t';
    t.textContent = title;
    row.appendChild(t);
    row.appendChild(btn('', '/search', 'Search', ICON.search));
    bar.appendChild(row);

    var subs = hero.querySelector('.beo-ch-subs');
    if (subs) {
      if (subs.getAttribute('aria-label') === 'Sub-categories') {
        var handle = (location.pathname.split('/collections/')[1] || '').split('/')[0];
        var parent = PARENT[handle] || handle;
        var all = document.createElement('a');
        all.className = 'beo-ch-sub' + (parent === handle ? ' beo-ch-sub--active' : ' beo-ch-sub--ghost');
        all.href = '/collections/' + parent;
        all.textContent = 'All';
        subs.insertBefore(all, subs.firstChild);
        subs.classList.add('beo-ch-subs--has-active');
      }
      bar.appendChild(subs);
      /* beo-collection-hero.liquid recale déjà la rangée sur la pastille active (à 400 ms
         et au load), mais avec un offsetLeft calculé avant le déplacement : on repasse
         après lui. « All » actif = rangée au début. */
      var act = subs.querySelector('.beo-ch-sub--active');
      /* 22/09 soir (« pas smooth quand on sélectionne French Pantry ») : la rangée se recalait
         3 fois après l'affichage (script du hero à 400 ms et au load, nous à 600 ms), d'où des
         sauts. Maintenant on la cale UNE fois, tout de suite, puis pendant 6 s on annule dans
         la même image tout recalage qui ne vient pas du doigt. */
      var target = 0;
      if (act && act !== subs.firstElementChild) {
        target = Math.max(0, subs.scrollLeft + act.getBoundingClientRect().left - subs.getBoundingClientRect().left - 16);
      }
      subs.scrollLeft = target;
      var touched = false, until = Date.now() + 6000;
      subs.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
      subs.addEventListener('scroll', function () {
        if (!touched && Date.now() < until && Math.abs(subs.scrollLeft - target) > 1) subs.scrollLeft = target;
      }, { passive: true });
    } else {
      bar.classList.add('beo-appbar--nosubs');
    }
    sec.parentNode.insertBefore(bar, sec.nextSibling);

    /* La ligne « retour · nom · loupe » apparaît quand la photo quitte l'écran. 46 px =
       hauteur de cette ligne, qui vit au-dessus de la barre (voir le CSS). */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        bar.classList.toggle('is-stuck', !es[0].isIntersecting);
      }, { rootMargin: '-46px 0px 0px 0px' }).observe(hero);
    }
  }

  /* Barre du haut sur les pages qui n'ont pas la leur (fiches produit, pages, journal) :
     retour + titre + loupe. Fleur (21/09) : « la barre de recherche est utile à garder
     partout ». Account est un onglet racine : pas de retour, mais le cadeau Rewards à sa
     place (23/09). Les pages qui ont déjà leur en-tête (home app, Market, collections,
     Flash Sale, panier, recherche) sont exclues. */
  function topbar() {
    var b = document.body.className;
    if (/template-(index|collection|search)\b/.test(b)) return;
    if (/template-page-(app-home|market)\b/.test(b)) return;
    if (document.querySelector('.beo-apptop, .beo-appbar, .beo-apphead')) return;
    var main = document.querySelector('main') || document.body;
    /* Account et panier sont des onglets racines : pas de retour, le logo au centre. Sur le
       panier, Fleur (22/09) : « il faudrait le logo pour que l'on sache chez qui on paie ». */
    var root = /template-(page-account|cart)\b/.test(b);
    var bar = document.createElement('div');
    bar.className = 'beo-apptop';
    if (root) {
      /* Onglet Account : la place de gauche était vide, elle porte maintenant le cadeau
         (Capucine 23/09 : « voit-on déjà la page Rewards ? »). Panier : on la laisse vide,
         rien ne doit détourner du paiement. */
      if (/template-page-account\b/.test(b)) {
        bar.appendChild(btn('', '/pages/rewards', 'Rewards', ICON.gift));
      } else {
        var sp = document.createElement('span');
        sp.className = 'beo-apptop__sp';
        bar.appendChild(sp);
      }
    } else {
      bar.appendChild(btn('', '/pages/market', 'Back', ICON.back));
    }
    var t = document.createElement('span');
    t.className = 'beo-apptop__t';
    /* Account : le logo au centre (Fleur : « le retirer partout sauf Account »). L'en-tete du
       site est masque dans l'app des le <head>, on reprend donc son image. */
    var logo = root ? document.querySelector('#site-header .logo img') : null;
    if (logo) {
      var im = document.createElement('img');
      im.src = logo.currentSrc || logo.src;
      im.alt = 'BONEATO';
      im.className = 'beo-apptop__logo';
      t.appendChild(im);
    } else {
      var h1 = /template-product\b/.test(b) ? null : main.querySelector('h1');
      t.textContent = h1 ? h1.textContent.trim() : '';
      /* Article du Journal : le titre, long, sortait coupé (« … ») juste au-dessus du même titre
         en entier. La barre dit où l'on est, l'article garde son titre (Fleur 10/10). */
      if (/template-article\b/.test(b)) t.textContent = 'The BONEATO Journal';
    }
    bar.appendChild(t);
    if (!logo) dedupeTitle(main, t.textContent);
    bar.appendChild(btn('', '/search', 'Search', ICON.search));
    main.insertBefore(bar, main.firstChild);
  }

  /* TITRE EN DOUBLE (Fleur 10/10 : « il y a répétition de BONEATO Rewards et ça me dérange »).
     La barre recopie le H1 : toute page dont l'en-tête répète ce texte l'affichait deux fois
     (Rewards, How Flash Sales work, Journal, pages légales, 404, et le surtitre vert de About,
     Contact, Delivery qui vient du contenu des pages). On masque, dans l'app seulement, les
     titres et surtitres du HAUT de page dont le texte est exactement celui de la barre. Le
     test « en haut » (< 500 px) protège un titre de section plus bas qui porterait le même mot. */
  function dedupeTitle(main, txt) {
    var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
    var want = norm(txt);
    if (!want) return;
    main.querySelectorAll('h1, .beo-title').forEach(function (el) {
      if (el.closest('.beo-apptop') || norm(el.textContent) !== want) return;
      if (el.getBoundingClientRect().top + window.scrollY > 500) return;
      el.style.setProperty('display', 'none', 'important');
      /* Cadre qui ne contenait que ce titre (pages légales : .shopify-policy__title) : il
         laissait un blanc avec ses marges. */
      var p = el.parentElement;
      if (p && p !== main && p.children.length === 1) p.style.setProperty('display', 'none', 'important');
    });
  }

  /* REWARDS SUR LA HOME DE L'APP (Capucine 23/09 : « voit-on déjà la page Rewards ? je ne suis
     pas sûre de la voir »). La page /pages/rewards existe, mais dans l'app TOUS ses liens sont
     dans l'en-tête et le pied de page du site, tous deux masqués : elle n'était atteignable que
     par la ligne « Rewards » de l'onglet Account, en troisième position. Le cadeau se pose donc
     à côté de la loupe, en haut à droite de la home. La barre est une grille à 3 colonnes
     (Delivery · mot BONEATO · loupe) : le cadeau et la loupe passent ensemble dans la dernière,
     sinon la grille se décale et Delivery ne serait plus à gauche. Site inchangé. */
  function homeGift() {
    var bar = document.querySelector('.bhz-topbar');
    if (!bar || bar.querySelector('.beo-giftbtn')) return;
    var search = bar.querySelector('.bhz-search:not(.bhz-truck)');
    if (!search) return;
    /* 2026-10-05 (Fleur) : la colonne de droite existe déjà dans le Liquid (camion · loupe), le
       logo ayant pris la place de Delivery à gauche. Le cadeau s'y glisse juste avant la loupe,
       donc à droite du camion. Sinon, ancien comportement : on fabrique la colonne. */
    var grp = bar.querySelector('.bhz-right');
    if (!grp) {
      grp = document.createElement('span');
      grp.className = 'bhz-right';
      bar.insertBefore(grp, search);
    }
    var g = document.createElement('a');
    g.className = 'bhz-search beo-giftbtn';
    g.href = '/pages/rewards';
    g.setAttribute('aria-label', 'Rewards');
    g.innerHTML = ICON.gift;
    grp.insertBefore(g, search.parentNode === grp ? search : null);
    if (search.parentNode !== grp) grp.appendChild(search);
  }

  /* ÉCRAN D'ATTENTE ENTRE DEUX PAGES (Capucine 23/09 : « il faudrait pareil au chargement des
     pages »). Un voile crème avec le logo au milieu, à la place de l'attente sur la page
     précédente. Styles en ligne : l'élément est fabriqué ici, tout se lit au même endroit.

     23/09, 2e version (« ça ne fonctionne pas »). Trois choses qui pouvaient l'empêcher de se
     voir, toutes corrigées :
     a. il était fabriqué au moment de l'afficher, donc le logo n'était téléchargé qu'à cet
        instant-là : trop tard, la page suivante arrivait avant. Il est maintenant préparé dès
        le chargement de la page, image comprise ;
     b. l'apparition passait par requestAnimationFrame et une transition d'opacité. Quand une
        navigation est en cours, le navigateur peut ne plus appeler requestAnimationFrame : le
        voile restait alors invisible. Il passe maintenant à l'opacité 1 directement ;
     c. le délai (260 ms) + le fondu (180 ms) dépassaient le temps de réponse de nos pages
        (mesuré : la plupart arrivent bien avant). Délai ramené à 170 ms, sans fondu.
     Il reste un délai : une page qui arrive tout de suite ne doit pas faire clignoter un écran
     de chargement, c'est ça qui fait « site web ».

     POUR LE VOIR SANS ATTENDRE : ajouter ?beo_load=1 à n'importe quelle URL, le voile s'affiche
     1,5 s à l'ouverture de la page. C'est un mode démo, il ne se déclenche jamais tout seul.

     Pastilles et onglets de la Flash Sale sont exclus : ils ont déjà leur propre retour (la
     pastille passe active, la grille s'estompe), un voile par-dessus le gâcherait.
     Il disparaît avec la nouvelle page (c'est un autre document), au retour arrière (pageshow,
     même depuis le cache) et au bout de 8 s si le lien n'a pas navigué.
     ⚠️ MobiLoud a son propre chargeur natif : si le leur s'affiche par-dessus, c'est le leur
     qu'on voit, et le nôtre ne sert que dans la webview. Question posée à Diego. */
  function pageLoader() {
    var DELAY = 170;
    var veil = document.createElement('div');
    veil.setAttribute('aria-hidden', 'true');
    veil.style.cssText = 'position:fixed;inset:0;z-index:9999;display:none;' +
      'background:#F5EEE4 url("' + LOGO + '") center/170px auto no-repeat;';
    document.body.appendChild(veil);
    new Image().src = LOGO;
    var timer = null, safety = null;
    function show() { veil.style.display = 'block'; }
    function hide() { clearTimeout(timer); clearTimeout(safety); veil.style.display = 'none'; }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.closest('.beo-ch-subs, .flash-nav-inner')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (a.host && a.host !== location.host) return;
      if (a.pathname === location.pathname && a.search === location.search) return;
      clearTimeout(timer);
      clearTimeout(safety);
      timer = setTimeout(show, DELAY);
      safety = setTimeout(hide, 8000);
    });
    window.addEventListener('pageshow', hide);
    if (/[?&]beo_load=1/.test(location.search)) { show(); setTimeout(hide, 1500); }
  }

  /* « Start shopping » (About us) et les autres liens vers /collections/all : dans l'app,
     ils mènent au Market. Sur le site, rien ne change. */
  /* Pick Your Mood : dans l'app, TOUS les liens mènent directement aux produits, c'est-à-dire à
     la collection BBQ & Grill, dont la barre de pastilles donne accès aux 12 moods (comme dans le
     Market du site). Capucine le 22/09 au soir : pas de page intermédiaire qui range les moods
     par catégorie entre le clic et les produits. La page /pages/pick-your-mood reste pour le
     site ; si l'app y arrive quand même (ancien lien, onglet), elle est renvoyée vers les produits. */
  var MOOD_PRODUCTS = '/collections/bbq-grill-delivery-hong-kong';
  if (location.pathname.replace(/\/$/, '') === '/pages/pick-your-mood') location.replace(MOOD_PRODUCTS + location.search);

  function allToMarket() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href').split('?')[0].replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '');
      if (h === '/collections/all') a.setAttribute('href', '/pages/market');
      else if (h === '/pages/pick-your-mood') a.setAttribute('href', MOOD_PRODUCTS);
      /* Accueil du SITE (logo du footer, fil d'Ariane « Home ») : dans l'app il ouvrait la home
         du site web, d'où la « sortie vers le site » vue à la réunion MobiLoud du 22/09. Il
         mène maintenant à la home de l'app. */
      else if (h === '' && a.host === location.host && /^(https?:\/\/[^/]+)?\/$/.test(a.getAttribute('href').split('?')[0])) a.setAttribute('href', '/pages/app-home');
    });
  }

  /* WHATSAPP (01/11) : dans l'app, la bulle flottante n'ouvrait pas WhatsApp alors que
     « Help on WhatsApp » (onglet Account) l'ouvre, avec exactement la même adresse wa.me.
     Seule différence entre les deux liens : target="_blank" sur la bulle (et sur « WhatsApp us »
     du panier vide, « Ask us on WhatsApp » de la recherche sans résultat). On retire target au
     moment du clic, sur tout lien WhatsApp, pour qu'il se comporte comme celui de l'Account.
     Au clic plutôt qu'au chargement : couvre aussi les liens posés après coup (panier en ajax).
     Sur le site, rien ne change : le lien garde son nouvel onglet. */
  function whatsappSameWindow() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || !a.hasAttribute('target')) return;
      if (/^whatsapp:/i.test(a.getAttribute('href')) || /(^|\.)(wa\.me|whatsapp\.com)$/i.test(a.hostname)) a.removeAttribute('target');
    }, true);
  }

  /* Page d'erreur dans l'app : on affiche l'adresse demandée (21/09, l'onglet Account tombe
     sur « Page not found » et on ne voit pas le réglage de MobiLoud). Une capture d'écran
     suffit alors à savoir ce que l'onglet vise. */
  function show404Path() {
    if (!document.body.classList.contains('template-404')) return;
    var host = document.querySelector('main') || document.body;
    var p = document.createElement('p');
    p.className = 'beo-404-path';
    p.textContent = 'Address: ' + location.host + location.pathname + location.search;
    host.appendChild(p);
  }

  /* INTERACTIONS FAÇON iOS (Capucine 22/09 soir : « rends tous les boutons et interactions
     méga smooth, à la iOS »). Trois choses, toutes réservées à l'app :
     1. appui : tout ce qui se touche s'enfonce doucement et revient avec un léger rebond
        (classes .beo-press / .beo-release, CSS section 15 de beo-app-only.css) ;
     2. pastilles (moods, sous-catégories) : au tap, la pastille passe active TOUT DE SUITE,
        la rangée glisse vers elle et la grille s'estompe, pendant que la page suivante
        arrive (avant : rien ne bougeait, puis écran blanc) ;
     3. préchargement de la page visée dès que le doigt se pose (Android ; iPhone l'ignore).
     Le fondu entre les pages est posé dans snippets/head-preloader.liquid (il doit être
     dans le <head> des deux pages).

     23/09, Capucine : « ça marche sur certaines pastilles et pas sur d'autres, et pas toujours
     les mêmes ». Trois causes trouvées, corrigées ici :
     a. un élément DÉJÀ transformé par le thème était purement et simplement ignoré (les ronds
        de la home sont centrés en translate, une pastille qui rebondit encore porte un
        transform, etc.). On compose maintenant l'enfoncement AVEC sa transformation, en style
        en ligne — qui bat le !important de la feuille — donc plus personne n'est laissé de côté ;
     b. un appui très bref se terminait avant d'être visible (la descente dure 100 ms) : il
        tient maintenant 130 ms au minimum, comme sur iOS ;
     c. le moindre évènement de défilement l'annulait, y compris le recalage AUTOMATIQUE de la
        rangée de pastilles — d'où « pas toujours les mêmes » : seules les pastilles qui
        faisaient glisser la rangée perdaient leur appui. On n'annule plus que si le doigt a
        vraiment bougé (12 px) ou si la page a réellement défilé. */
  var BIG = '.product-item, .bhz-band, .bhz-about, .bhz-flash';
  var TOUCHABLE = '.beo-add-btn, button, [role="button"], .beo-ch-sub, .beo-appbtn, .beo-acct__row, .bhz-search, .bhz-delivery, .flash-nav-tab';
  function pressFeedback() {
    var MIN = 130, MOVE = 12;
    var cur = null, timer = null, done = {};
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Le conteneur qui défile autour de l'élément (la rangée de pastilles, par exemple) :
       s'il a bougé entre le poser et le lever du doigt, c'était un glissement, pas un appui. */
    function scrollerOf(el) {
      for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        var s = getComputedStyle(p);
        if (/(auto|scroll)/.test(s.overflowX + ' ' + s.overflowY)) return p;
      }
      return null;
    }
    function end(p, bounce) {
      p.el.classList.remove('beo-press', 'beo-press--big');
      if (p.tf) p.el.style.removeProperty('transform');
      if (!bounce) return;
      p.el.classList.add('beo-release');
      setTimeout(function () { p.el.classList.remove('beo-release'); }, 450);
    }
    function release(bounce) {
      if (!cur) return;
      var p = cur;
      cur = null;
      clearTimeout(timer);
      if (bounce && (Math.abs(window.pageYOffset - p.py) > 4 ||
          (p.sc && (p.sc.scrollLeft !== p.sl || p.sc.scrollTop !== p.st)))) bounce = false;
      var left = MIN - (Date.now() - p.t0);
      if (bounce && left > 0) timer = setTimeout(function () { end(p, true); }, left);
      else end(p, bounce);
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      var t = e.target;
      if (!t.closest || t.closest('input, select, textarea')) return;
      var el = t.closest(TOUCHABLE) || t.closest('.product-item') || t.closest('a[href]');
      if (!el) return;
      release(false);
      /* Retirer le rebond en cours AVANT de lire la transformation : sinon l'élément qu'on
         retouche tout de suite paraît « déjà transformé » et n'avait plus d'appui du tout. */
      el.classList.remove('beo-release');
      var tf = getComputedStyle(el).transform;
      if (tf === 'none' || calm) tf = '';
      var sc = scrollerOf(el);
      cur = {
        el: el, tf: tf, t0: Date.now(), x0: e.clientX, y0: e.clientY,
        py: window.pageYOffset, sc: sc, sl: sc ? sc.scrollLeft : 0, st: sc ? sc.scrollTop : 0
      };
      var big = el.matches(BIG) || el.offsetWidth > 220;
      el.classList.toggle('beo-press--big', big);
      if (tf) el.style.setProperty('transform', tf + (big ? ' scale(.975)' : ' scale(.95)'), 'important');
      el.classList.add('beo-press');
      var a = t.closest('a[href]');
      var h = a && a.getAttribute('href');
      if (h && h.charAt(0) === '/' && h.charAt(1) !== '/' && !done[h]) {
        done[h] = 1;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = h;
        document.head.appendChild(l);
      }
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (cur && (Math.abs(e.clientX - cur.x0) > MOVE || Math.abs(e.clientY - cur.y0) > MOVE)) release(false);
    }, { passive: true });
    /* pointercancel arrive dès que le navigateur se demande si le doigt va faire défiler —
       très souvent dans une rangée qui défile. Ce n'est donc PAS une raison d'annuler :
       release() regarde si quelque chose a réellement défilé pour trancher. */
    ['pointerup', 'pointercancel', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () { release(true); }, { passive: true, capture: true });
    });
    document.addEventListener('dragstart', function () { release(false); }, { passive: true });
    /* Seul le défilement de la PAGE annule (les rangées de pastilles se recalent toutes
       seules au chargement : leur défilement ne doit rien annuler). */
    window.addEventListener('scroll', function () {
      if (cur && Math.abs(window.pageYOffset - cur.py) > 4) release(false);
    }, { passive: true });
    window.addEventListener('pageshow', function () {
      release(false);
      document.body.classList.remove('beo-navigating');
    });
  }

  function pillTaps() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.beo-ch-sub[href]');
      if (!a || a.classList.contains('beo-ch-sub--active') || e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      var row = a.parentNode;
      row.querySelectorAll('.beo-ch-sub--active').forEach(function (o) {
        o.classList.remove('beo-ch-sub--active');
        o.classList.add('beo-ch-sub--ghost');
        o.removeAttribute('aria-current');
        var tick = o.querySelector('.beo-ch-sub__tick');
        if (tick) a.insertBefore(tick, a.firstChild);
      });
      a.classList.remove('beo-ch-sub--ghost');
      a.classList.add('beo-ch-sub--active');
      a.setAttribute('aria-current', 'page');
      /* Touchée depuis la barre collée en haut : la page suivante s'ouvre au même endroit
         (ancre #beo-filters, section 19 du CSS) au lieu de repartir tout en haut. */
      var bar = a.closest('.beo-appbar');
      if (bar && bar.classList.contains('is-stuck') && document.getElementById('beo-filters')) {
        a.setAttribute('href', a.getAttribute('href').split('#')[0] + '#beo-filters');
      }
      var left = row.scrollLeft + a.getBoundingClientRect().left - row.getBoundingClientRect().left - 16;
      if (row.scrollTo) row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      document.body.classList.add('beo-navigating');
    });
  }

  /* PARTAGER LE PANIER (retour Capucine 29/09, point 10). Shopify recrée un panier depuis un lien
     /cart/<variante>:<quantité>,... : on le fabrique à partir de /cart.js au moment du clic, donc
     toujours à jour même après un ajax. Feuille de partage du téléphone si elle existe, sinon
     copie dans le presse-papier. Le lien part du domaine courant : il suivra boneato.hk le jour
     du changement de DNS. Pour qu'il ouvre l'app plutôt que le site, MobiLoud doit livrer les
     Universal Links dans le prochain build. Bouton masqué quand le panier est vide (CSS). */
  function shareCart() {
    if (!document.body.classList.contains('template-cart')) return;
    var holder = document.querySelector('.cart-holder');
    if (!holder || document.querySelector('.beo-share')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'beo-share';
    b.innerHTML = ICON.share + '<span>Share cart</span>';
    var label = b.querySelector('span');
    var flash = function (t) { label.textContent = t; setTimeout(function () { label.textContent = 'Share cart'; }, 2000); };
    b.addEventListener('click', function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items || !c.items.length) return;
        var url = location.origin + '/cart/' + c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        // 03/11 : lien et événement de suivi des partages, voir assets/beo-app-ux.js (BEOShare)
        var S = window.BEOShare;
        if (S) url = S.url(url, 'cart', 'cart');
        var done = function (method) { if (S) S.done({ content_type: 'cart', method: method, campaign: 'cart' }); };
        if (navigator.share) {
          navigator.share({ title: 'My BONEATO cart', url: url }).then(function () { done('share_sheet'); }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { done('copy'); flash('Link copied'); }, function () { flash('Copy failed'); });
        } else {
          flash('Not supported');
        }
      }).catch(function () { flash('Try again'); });
    });
    holder.parentNode.insertBefore(b, holder.nextSibling);
  }

  function run() {
    pressFeedback();
    shareCart();
    pillTaps();
    pageLoader();
    cleanCards();
    allToMarket();
    whatsappSameWindow();
    show404Path();
    homeGift();
    if (document.body.classList.contains('template-collection-flash_sale')) flash();
    else if (document.querySelector('.beo-ch-v2')) collection();
    else topbar();
    /* Cartes ajoutées plus tard (filtres, pagination en place) : même nettoyage. */
    var grid = document.querySelector('.collection.grid');
    if (grid && 'MutationObserver' in window) new MutationObserver(cleanCards).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
